import commfun from '../commontools/CommonFun.js'
import apiReq from '../commontools/api.js'
export function GetAllUser() {
	var url = '/User/GetAllUser';
	return apiReq.get(url);
}
export function GetUserByValid() {
	var url = '/User/GetUserByValid';
	return apiReq.get(url);
}
export function UserNameCanUse(username) {
	var url = '/User/UserNameCanUse/' + username;
	return apiReq.get(url);
}
export function EditPwd(id, pwd) {
	var url = '/User/EditPwd/' + id + '/' + pwd;
	return apiReq.get(url);
}
export function AddUser(userinfo) {
	var url = '/User/AddUser'
	var p = {
		'data': userinfo
	}
	return apiReq.post(url, p);
}
export function EditUser(userinfo) {
	var url = '/User/EditUser';
	var p = {
		'data': userinfo
	}
	return apiReq.post(url, p);
}
export function CanLogin(uid, pwd) {
	var url = '/User/CanLogin/' + uid + '/' + commfun.EncryptMd5(pwd);
	return apiReq.get(url);

}
export function GetUserOrderRight(uid) {
	var url = '/User/GetUserOrderRight/' + uid;
	return apiReq.get(url);
}
export default {
	CanLogin,
	GetAllUser,
	UserNameCanUse,
	AddUser,
	EditUser,
	EditPwd,
	GetUserOrderRight
}
